import { DoMoreProps, MessageType } from 'components/do-more/do-more'
import globalConfig from 'init/global.config'
import { TurnToFlow } from './email-flow-entry'
import submissionLoader from 'widgets/submission/submission-loader'
import submissionStore, { SubmissionPage } from 'store/submission-store'

const FLOW_DATA = {
  qco: { rf: 'question', rq: 'optional' },
  qcr: { rf: 'question', rq: 'required' },
  aco: { rf: 'answer', rq: 'optional' },
  acr: { rf: 'answer', rq: 'required' },
  repco: { rf: 'reply', rq: 'optional' },
  repcr: { rf: 'reply', rq: 'required' },
  revco: { rf: 'review', rq: 'optional' },
  revcr: { rf: 'review', rq: 'required' }
}

const CONFIRMATION_FLOW_KEYS = Object.keys(FLOW_DATA)

/**
 * These flows are confirmation message flows.  In other words, there is no action to be taken,
 * only display a popover message to the user.
 *
 * @param flow
 * @param params
 * @param data
 */
export function checkForFlow(
  flow: TurnToFlow,
  params: { [name: string]: string }
): Promise<boolean> {
  return new Promise((resolve) => {
    if (CONFIRMATION_FLOW_KEYS.indexOf(flow) > -1) {
      if (params.tterr === '1101') {
        // expired confirmation token
        // tslint:disable-next-line
        import(/* webpackChunkName: 'expired-confirmation' */ 'components/expired-confirmation/expired-confirmation-loader').then((expiredConfirmationLoader) => {
          expiredConfirmationLoader.default.load({
            registerFor: FLOW_DATA[flow].rf,
            registrationQualifier: FLOW_DATA[flow].rq,
            token: params.ttrtok
          })
        })
        resolve(true)
        return
      }
      // open Do More with appropriate message
      let messageType = FLOW_DATA[flow].rf as MessageType
      if (messageType === 'question' && globalConfig.isAllowAnon()) {
        messageType = 'questionAnon'
      }
      submissionStore.currentPage = {
        page: 'do-more',
        props: { msgType: messageType } as DoMoreProps
      } as SubmissionPage
      submissionLoader.load()
      resolve(true)
    } else {
      resolve(false)
    }
  })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/email-flows/confirmation-message-flows.ts